import { AccountApi } from '@calm/evexia-web-sdk/generated/lib/api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `AccountApi`
 * @param accessToken
 * @returns
 */
export default function createAccountApi(accessToken: () => Promise<string>) {
    return createApi(AccountApi, accessToken);
}
